const themeContract = {
  tu: {
    border: {
      visible: true
    },
    background: {
      color: 'lighter'
    }
  },
  argos: {
    border: {
      visible: true
    },
    background: {
      color: 'lighter'
    }
  },
  habitat: {
    border: {
      visible: false
    },
    background: {
      color: 'lighter'
    }
  },
  nectar: {
    border: {
      visible: false
    },
    background: {
      color: 'white'
    }
  },
  sainsburys: {
    border: {
      visible: false
    },
    background: {
      color: 'white'
    }
  }
}

export { themeContract }
